import { alpha } from '@mui/material/styles';
import { tss } from 'tss-react/mui';

export const useStyles = tss.create(({ theme }) => ({
  root: {
    width: '100%',
    maxWidth: 1040,
    padding: theme.spacing(1),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(3),
    },
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(3, 4),
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2.5),
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
  },
  headerCopy: {
    minWidth: 0,
  },
  headerActions: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    flexShrink: 0,
  },
  uploadButton: {
    textTransform: 'none',
  },
  hiddenFileInput: {
    display: 'none',
  },
  uploadProgress: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(0.75),
  },
  errorMessage: {
    color: theme.palette.error.main,
  },
  searchInput: {
    width: '100%',
  },
  searchIcon: {
    marginRight: theme.spacing(1),
  },
  fileList: {
    display: 'grid',
    gridTemplateColumns: 'minmax(0, 1fr)',
    gap: theme.spacing(2),
  },
  fileCard: {
    borderRadius: theme.shape.borderRadius,
    boxShadow: theme.shadows[0],
  },
  fileCardContent: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(2.5),
    minWidth: 0,
    '&&': {
      padding: theme.spacing(0.25),
    },
  },
  fileInfo: {
    flex: 1,
    minWidth: 0,
  },
  fileName: {
    minWidth: 0,
  },
  fileMetadata: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  fileError: {
    display: 'block',
    marginTop: theme.spacing(0.5),
    color: theme.palette.error.main,
  },
  agentList: {
    marginTop: theme.spacing(0.5),
    gap: theme.spacing(0.5),
  },
  agentChip: {
    height: theme.spacing(3),
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.main,
    fontWeight: theme.typography.fontWeightMedium,
  },
  fileActions: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
    flexShrink: 0,
    marginLeft: 'auto',
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing(0.5),
    },
  },
  statusChip: {
    height: theme.spacing(4.5),
    paddingLeft: theme.spacing(1.25),
    paddingRight: theme.spacing(1.25),
  },
  statusReady: {
    backgroundColor: theme.palette.success.light,
    color: theme.palette.success.dark,
  },
  statusFailed: {
    backgroundColor: theme.palette.error.light,
    color: theme.palette.error.dark,
  },
  statusProcessing: {
    backgroundColor: theme.palette.warning.light,
    color: theme.palette.warning.dark,
  },
  enabledControl: {
    margin: 0,
    gap: theme.spacing(0.25),
    flexShrink: 0,
    '& .MuiFormControlLabel-label': {
      display: 'inline-block',
      width: theme.spacing(7),
      whiteSpace: 'nowrap',
      fontSize: theme.typography.body1.fontSize,
      fontWeight: theme.typography.body1.fontWeight,
      lineHeight: theme.typography.body1.lineHeight,
    },
  },
  detailsButton: {
    minWidth: theme.spacing(11.75),
    height: theme.spacing(4.5),
    textTransform: 'none',
    boxShadow: theme.shadows[0],
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.main,
    '&:hover': {
      boxShadow: theme.shadows[0],
      backgroundColor: alpha(theme.palette.primary.main, 0.14),
    },
  },
  actionButton: {
    color: theme.palette.text.secondary,
  },
  deleteButton: {
    color: theme.palette.error.main,
  },
  detailsStack: {
    gap: theme.spacing(1.25),
  },
  detailsError: {
    color: theme.palette.error.main,
  },
  assignmentSection: {
    gap: theme.spacing(2),
    marginTop: theme.spacing(1),
  },
  assignmentActions: {
    gap: theme.spacing(1),
    flexWrap: 'wrap',
  },
  assignmentButton: {
    textTransform: 'none',
  },
  searchSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  searchForm: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
    },
  },
  documentSearchInput: {
    flex: 1,
    minWidth: 0,
  },
  searchButton: {
    minWidth: theme.spacing(11.5),
    height: theme.spacing(5),
    textTransform: 'none',
  },
  searchError: {
    color: theme.palette.error.main,
  },
  searchResults: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    marginTop: theme.spacing(0.5),
  },
  searchResult: {
    padding: theme.spacing(1.25),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.action.hover,
  },
  searchResultFragment: {
    whiteSpace: 'pre-wrap',
    overflowWrap: 'anywhere',
  },
  searchResultMeta: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1.5),
    marginTop: theme.spacing(0.75),
  },
  searchResultScore: {
    fontWeight: theme.typography.h6.fontWeight,
    color: theme.palette.primary.main,
  },
}));
